import CryptoJS from 'crypto-js';


// 加密
export function aesEncrypt(str) {
    return CryptoJS.AES.encrypt(str, "uq43TK;8wl*jv").toString();
}

// 解密
export function aesDecrypt(str) {
    if (str !== null) {
        return CryptoJS.AES.decrypt(str, "uq43TK;8wl*jv").toString(CryptoJS.enc.Utf8);
    }
}


export function shaEncrypt(str) {
    return CryptoJS.SHA256(str).toString();
}